// The browser reaches leads-api through server/api/leads-api, which holds the JWT
export const API_PROXY_BASE = '/api/leads-api'

// Required on every proxied request: cross-site forms cannot set a custom
// header, so another site cannot use the session cookie to act as the user
export const API_PROXY_HEADER = 'X-Requested-With'
export const API_PROXY_HEADER_VALUE = 'leads-front'
